export default "__VITE_ASSET__DXmp8Zfp__"